// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"708":"67c34043","962":"472b23e5"}[chunkId] + ".js";
};